import React, { useEffect } from "react";
import ProfileEmptyState from "../ProfileEmptyState/ProfileEmptyState.tsx";
import styles from "./GestionSectionTeaser.module.scss";
import { GESTION_SECTION_QUERY_TO_LABEL, type ProfileGestionSection } from "../../../../utils/navigationHelpers.ts";

interface GestionSectionTeaserProps {
  section: ProfileGestionSection;
  setInfoReady: (ready: boolean) => void;
}

const GestionSectionTeaser: React.FC<GestionSectionTeaserProps> = ({
  section,
  setInfoReady,
}) => {
  useEffect(() => {
    setInfoReady(true);
  }, [setInfoReady]);

  const title = GESTION_SECTION_QUERY_TO_LABEL[section];

  return (
    <div className={styles.wrap}>
      <span className={styles.badge}>Próximamente</span>
      <ProfileEmptyState
        illustration="documentation"
        title={title}
        description="Estamos preparando esta sección para que puedas organizar y compartir la documentación de tus obras desde tu perfil."
        className={styles.emptyState}
      />
    </div>
  );
};

export default GestionSectionTeaser;
